import { forwardRef, type ReactNode, type Ref } from 'react';
import clsx from 'clsx';
import { Heading, Paragraph } from '@hungryroot/ramen';

import styles from './Toggle.module.css';
import layoutStyles from '../../../Page/layout.module.css';

export enum ToggleVariant {
  One = 'toggle-variant-one',
  Two = 'toggle-variant-two',
  Three = 'toggle-variant-three',
  EatingHabits = 'toggle-variant-eating-habits',
}

interface ToggleProps {
  testid?: string;
  label: string;
  active: boolean;
  variant: ToggleVariant;
  style?: Record<string, unknown>;
  className?: string;
}

export interface ToggleOneProps extends ToggleProps {
  illustration: ReactNode;
  subcopy?: null;
}

export interface ToggleTwoProps extends ToggleProps {
  illustration?: null;
  subcopy?: null;
}

export interface ToggleThreeProps extends ToggleProps {
  illustration: ReactNode;
  subcopy?: string | null;
}

type Props = ToggleOneProps | ToggleTwoProps | ToggleThreeProps;

export const Toggle = forwardRef((props: Props, ref: Ref<HTMLDivElement>) => {
  const {
    label,
    testid,
    active,
    variant,
    illustration,
    subcopy,
    style,
    className,
  } = props;

  return (
    <div
      data-active-state={active}
      ref={ref}
      className={clsx(
        { [styles.active]: active },
        styles[variant],
        layoutStyles['slide-in'],
        className,
        styles['toggle-item']
      )}
      data-testid={testid}
      style={style}
    >
      {illustration}
      <div>
        <Heading variant="H6" testid={`${testid}-label`}>
          {label}
        </Heading>
        {subcopy ? (
          <Paragraph testid={`${testid}-subcopy`}>{subcopy}</Paragraph>
        ) : null}
      </div>
    </div>
  );
});
